// extracted by mini-css-extract-plugin
module.exports = {"forecastList":"WeatherFaq_forecastList__00Jvp"};